module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/face_warm.47178794.svg";